import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { BannerComponent } from './components/banner/banner.component';
import { EventDetailComponent } from './components/event-detail/event-detail.component';
import { EventComponent } from './components/event/event.component';
import { EventsBetTypeGroupsComponent } from './components/events-bet-type-groups/events-bet-type-groups.component';
import { EventsGroupComponent } from './components/events-group/events-group.component';
import { EventsHeaderComponent } from './components/events-header/events-header.component';
import { FilterNavigationMenuComponent } from './components/filter-navigation-menu/filter-navigation-menu.component';
import { HeadToHeadWidgetComponent } from './components/head-to-head-widget/head-to-head-widget.component';
import { LoaderComponent } from './components/loader/loader.component';
import { MatchPreviewWidgetComponent } from './components/match-preview-widget/match-preview-widget.component';
import { EventLiveDetailMobileComponent } from './components/mobile/event-live-detail-mobile/event-live-detail-mobile.component';
import { EventMobileComponent } from './components/mobile/event-mobile/event-mobile.component';
import { EventsGroupMobileComponent } from './components/mobile/events-group-mobile/events-group-mobile.component';
import { EventsLiveMobileComponent } from './components/mobile/events-live-mobile/events-live-mobile.component';
import { FilterMobileComponent } from './components/mobile/filter/filter-mobile.component';
import { MyTicketsMobileComponent } from './components/mobile/my-tickets-mobile/my-tickets-mobile.component';
import { ResultsEventDetailsMobileComponent } from './components/mobile/results-event-details-mobile/results-event-details-mobile.component';
import { ResultsEventMobileComponent } from './components/mobile/results-event-mobile/results-event-mobile.component';
import { ResultsEventsGroupMobileComponent } from './components/mobile/results-events-group-mobile/results-events-group-mobile.component';
import { ResultsSportCompetitionTreeMobileComponent } from './components/mobile/results-sport-competition-tree-mobile/results-sport-competition-tree-mobile.component';
import { ResultsSportSelectionContainerMobileComponent } from './components/mobile/results-sport-selection-container-mobile/results-sport-selection-container-mobile.component';
import { SpecialEventsMobileComponent } from './components/mobile/special-events-mobile/special-events-mobile.component';
import { SportTreeSelectionContainerMobileComponent } from './components/mobile/sport-tree-selection-container-mobile/sport-tree-selection-container-mobile.component';
import { SportsCompetitionTreeMobileComponent } from './components/mobile/sports-competitio-tree/sports-competitio-tree-mobile.component';
import { MyTicketDetailsComponent } from './components/mobile/ticket/my-ticket-details/my-ticket-details.component';
import { MyTicketsMobileV2Component } from './components/mobile/ticket/my-tickets-mobile-v2/my-tickets-mobile-v2.component';
import { TicketDialogMobileV2Component } from './components/mobile/ticket/ticket-dialog-mobile-v2/ticket-dialog-mobile-v2.component';
import { TicketMobileComponent } from './components/mobile/ticket/ticket-mobile.component';
import { TicketSystemMobileComponent } from './components/mobile/ticket/ticket-system/ticket-system-mobile.component';
import { NotificationDialogComponent } from './components/notification-dialog/notification-dialog.component';
import { ResultsEventDetailsComponent } from './components/results-event-details/results-event-details.component';
import { ResultsFilterComponent } from './components/results-filter/results-filter.component';
import { SearchEventsComponent } from './components/search-events/search-events.component';
import { SportNavBarComponent } from './components/sport-nav-bar/sport-nav-bar.component';
import { SportTreeSelectionContainerComponent } from './components/sport-tree-selection-container/sport-tree-selection-container.component';
import { SportsCompetitionTreeComponent } from './components/sports-competitio-tree/sportsCompetitionTree.component';
import { StreamingWidgetComponent } from './components/streaming-widget/streaming-widget.component';
import { StreamingWrapComponent } from './components/streaming-wrap/streaming-wrap.component';
import { StreamingComponent } from './components/streaming/streaming.component';
import { SvgDefinitionsComponent } from './components/svg/svg-definitions/svg-definitions.component';
import { SvgComponent } from './components/svg/svg-icon/svg-icon.component';
import { TicketDialogComponent } from './components/ticket-dialog/ticket-dialog.component';
import { TicketMenagerHeaderComponent } from './components/ticket-menager-header/ticket-menager-header.component';
import { TicketMenuBarComponent } from './components/ticket-menu-bar/ticket-menu-bar.component';
import { FindTicketComponent } from './components/ticket/find-ticket/find-ticket.component';
import { MyTicketComponent } from './components/ticket/my-ticket/my-ticket.component';
import { TicketCombiComponent } from './components/ticket/ticket-combi/ticket-combi.component';
import { TicketSingleComponent } from './components/ticket/ticket-single/ticket-single.component';
import { TicketSystemComponent } from './components/ticket/ticket-system/ticket-system.component';
import { TicketComponent } from './components/ticket/ticket.component';
import { WinningsPerHitComponent } from './components/winnings-per-hit/winnings-per-hit.component';
import { LazyForDirective } from './directive/lazyFor.directive';
import { NumberOnlyDirective } from './directive/number-only';
// import { MaterialModule } from './material.module';
import { HandicapSbvPipe } from './pipes/handicapSvbpipe';
import { OddPipe } from './pipes/oddpipe';
import { SplitPipe } from './pipes/splitpipe';
import { CashierSearchComponent } from './ticket-manager/components/cashier-search/cashier-search.component';
import { FastTicketValidationComponent } from './ticket-manager/components/fast-ticket-validation/fast-ticket-validation.component';
import { TicketPrintComponent } from './ticket-manager/components/ticket-print/ticket-print.component';
import { TicketToolsComponent } from './ticket-manager/components/ticket-tools/ticket-tools.component';
import { NgxBarcode6Module } from 'ngx-barcode6';
import { ZXingScannerModule } from '@zxing/ngx-scanner';

@NgModule({
  declarations: [
    FilterNavigationMenuComponent,
    SportNavBarComponent,
    BannerComponent,
    EventDetailComponent,
    TicketComponent,
    StreamingWrapComponent,
    NotificationDialogComponent,
    HeadToHeadWidgetComponent,
    TicketDialogComponent,
    TicketDialogMobileV2Component,
    LoaderComponent,
    FilterMobileComponent,
    SearchEventsComponent,
    SportsCompetitionTreeMobileComponent,
    ResultsSportCompetitionTreeMobileComponent,
    EventLiveDetailMobileComponent,
    TicketMobileComponent,
    ResultsEventDetailsComponent,
    StreamingComponent,
    StreamingWidgetComponent,
    OddPipe,
    SplitPipe,
    HandicapSbvPipe,
    EventsLiveMobileComponent,
    SportsCompetitionTreeComponent,
    FindTicketComponent,
    TicketCombiComponent,
    TicketSystemComponent,
    MyTicketComponent,
    TicketSingleComponent,
    MyTicketsMobileComponent,
    TicketMenuBarComponent,
    MyTicketsMobileV2Component,
    TicketSystemMobileComponent,
    MyTicketDetailsComponent,
    LazyForDirective,
    NumberOnlyDirective,
    WinningsPerHitComponent,
    MatchPreviewWidgetComponent,
    ResultsEventMobileComponent,
    ResultsEventDetailsMobileComponent,
    SvgComponent,
    SvgDefinitionsComponent,
    SportTreeSelectionContainerComponent,
    SportTreeSelectionContainerMobileComponent,
    EventsGroupComponent,
    ResultsFilterComponent,
    SpecialEventsMobileComponent,
    EventComponent,
    ResultsSportSelectionContainerMobileComponent,
    EventsHeaderComponent,
    ResultsEventsGroupMobileComponent,
    EventsGroupMobileComponent,
    EventMobileComponent,
    EventsBetTypeGroupsComponent,
    TicketComponent,
    TicketCombiComponent,
    TicketSystemComponent,
    TicketSingleComponent,
    WinningsPerHitComponent,
    FindTicketComponent,

    HandicapSbvPipe,
    MyTicketsMobileComponent,
    TicketDialogComponent,
    LoaderComponent,
    TicketMenagerHeaderComponent,
    TicketToolsComponent,
    CashierSearchComponent,
    TicketPrintComponent,
    FastTicketValidationComponent

  ],
  exports: [
    FilterNavigationMenuComponent,
    SportNavBarComponent,
    BannerComponent,
    EventDetailComponent,
    TicketComponent,
    StreamingWrapComponent,
    NotificationDialogComponent,
    HeadToHeadWidgetComponent,
    TicketDialogComponent,
    TicketDialogMobileV2Component,
    LoaderComponent,
    FilterMobileComponent,
    SearchEventsComponent,
    SportsCompetitionTreeMobileComponent,
    ResultsSportCompetitionTreeMobileComponent,
    EventLiveDetailMobileComponent,
    TicketMobileComponent,
    ResultsEventDetailsComponent,
    StreamingComponent,
    StreamingWidgetComponent,
    OddPipe,
    SplitPipe,
    HandicapSbvPipe,
    EventsLiveMobileComponent,
    SportsCompetitionTreeComponent,
    FindTicketComponent,
    TicketCombiComponent,
    TicketSystemComponent,
    MyTicketComponent,
    TicketSingleComponent,
    MyTicketsMobileComponent,
    TicketMenuBarComponent,
    MyTicketsMobileV2Component,
    TicketSystemMobileComponent,
    MyTicketDetailsComponent,
    LazyForDirective,
    NumberOnlyDirective,
    WinningsPerHitComponent,
    MatchPreviewWidgetComponent,
    ResultsEventMobileComponent,
    ResultsEventDetailsMobileComponent,
    SvgComponent,
    SvgDefinitionsComponent,
    SportTreeSelectionContainerComponent,
    SportTreeSelectionContainerMobileComponent,
    EventsGroupComponent,
    ResultsFilterComponent,
    EventsHeaderComponent,
    SpecialEventsMobileComponent,
    ResultsSportSelectionContainerMobileComponent,
    EventComponent,
    EventsGroupMobileComponent,
    ResultsEventsGroupMobileComponent,
    EventMobileComponent,
    EventsBetTypeGroupsComponent,

    MatDatepickerModule,
    MatFormFieldModule,
    TicketComponent,
    TicketCombiComponent,
    TicketSystemComponent,
    TicketSingleComponent,
    WinningsPerHitComponent,
    FindTicketComponent,
    HandicapSbvPipe,
    MyTicketsMobileComponent,
    TicketDialogComponent,
    LoaderComponent,
    TicketMenagerHeaderComponent,
    TicketToolsComponent,
    CashierSearchComponent,
    TicketPrintComponent,
    FastTicketValidationComponent,

    MatDatepickerModule,
    MatNativeDateModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatDialogModule,
    MatRippleModule,
    MatTooltipModule,
    MatSelectModule,
    FormsModule,
    ZXingScannerModule
  ],
  imports: [
    MatDatepickerModule,
    MatNativeDateModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatDialogModule,
    MatRippleModule,
    MatTooltipModule,
    MatSelectModule,
    CommonModule,
    FormsModule,
    RouterModule,
    NgxBarcode6Module,
    ZXingScannerModule
  ],
  providers: [
     MatDatepickerModule,
     MatNativeDateModule,
  ],
})
export class SharedComponentsModule {

}
